import formatNumber from '../formatNumber';
export default function bytes2Size(sizeInBytes) {
    if (sizeInBytes === 0) {
        return '0 bytes';
    }
    var decimalPlaces = 2;
    var c = 1024;
    var e = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var f = Math.floor(Math.log(sizeInBytes) / Math.log(c));
    var val = sizeInBytes / Math.pow(c, f);
    var rounded = val.toFixed(decimalPlaces);
    if (rounded === c.toFixed(decimalPlaces)) {
        return formatNumber(sizeInBytes / Math.pow(c, (f + 1)), decimalPlaces) + " " + e[f + 1];
    }
    return formatNumber(val, decimalPlaces) + " " + e[f];
}
